let scriptLoaded: Promise<void> | null = null
let scriptHasLoaded = false

export function loadBrightcoveScript(
  accountId: string,
  playerId: string
): Promise<void> {
  if (!scriptLoaded) {
    scriptLoaded = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `//players.brightcove.net/${accountId}/${playerId}_default/index.min.js?cbust=1`
      script.onload = () => {
        scriptHasLoaded = true
        resolve()
      }
      script.onerror = () => {
        scriptLoaded = null
        reject(new Error('Failed to load Brightcove script'))
      }
      document.body.appendChild(script)
    })
  }
  return scriptLoaded
}

export function isScriptAlreadyLoaded(): boolean {
  return scriptHasLoaded
}
